import { createProperties, type Field, type TypeToFields } from '@jmvdevelop/svelte-form';
import * as z from 'zod';
import { zFeedPostTagEnum } from '$gql/zod-generated';

export const zNewsfeedFiltersData = z.object({
    category: zFeedPostTagEnum.nullable(),
    subCategory: zFeedPostTagEnum.nullable(),
    types: z.array(zFeedPostTagEnum),
});

export type NewsfeedFiltersData = z.infer<typeof zNewsfeedFiltersData>;
type FormData = NewsfeedFiltersData;

export type Fields<TFormValues> = TypeToFields<TFormValues, FormData>;

export const empty: FormData = {
    types: [],
    category: null,
    subCategory: null,
};

export function createFields<TValues>(self: Field<TValues, FormData>): Fields<TValues> {
    return {
        self: self,
        ...createProperties(self, ['category', 'subCategory', 'types'] as const),
    };
}
